import { withStyles } from '../../tools/withStyles';
import { Component } from './MusicPlayer';
import { styles } from './MusicPlayer.styles';

const MusicPlayer = withStyles(styles)(Component);

export { MusicPlayer };
